export default __webpack_public_path__ + "static/media/keepitsecret.1259a987.png";